export default __webpack_public_path__ + "static/media/Css3Icon.067863de.svg";